import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProfileEditPage from './profile/ProfileEditPage';
import { RequisitesPage } from './requisites';

export default function SettingsProfilePage() {
  return (
    <Routes>
      <Route path='profile' element={<ProfileEditPage />} />
      <Route path='requisites' element={<RequisitesPage />} />
    </Routes>
  );
}
